module.exports = {
  "country": "EE",
  "artist": "Tanel Padar, Dave Benton & 2XL",
  "song": "Everybody",
  "year": "2001",
  "place": "1",
  "spotify": ""
};